// facilities--drawer-link — the Add trigger's half of opening a preloaded
// drawer (CONEK-7405).
//
// The Add form is already inside its drawer, so a plain click must only open
// the drawer (ui--drawer-opener#open, the next action) and must not follow the
// link's href to /new. A modified click — Cmd/Ctrl/Shift/middle, for a new tab
// — is left entirely to the browser: the default stays, and the remaining
// actions on the element (the drawer opening) are stopped.
import { Controller } from "@hotwired/stimulus"

import { isModifiedClick } from "./pristine_frame"

export default class extends Controller {
  open(event) {
    if (isModifiedClick(event)) {
      event.stopImmediatePropagation()
    } else {
      event.preventDefault()
    }
  }
}
